import { useState, useEffect } from "react";
import logoLg from "../../assets/images/lg-logo.png";
import crossBtn from "../../assets/images/clear.png";
import { Link } from "react-router-dom";
import { ErrorMessage, Formik } from "formik";
import * as Yup from "yup";
import visibility from "../../assets/icons/visibility.svg";
import visibilityOff from "../../assets/icons/visibility_off.svg";
import { connect } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { sendGetRequest, sendPostRequest } from "../../actions/app-actions";
import { withRouter, notification, passwordRegex } from "../../utils/utility";
import isEmpty from "../../validation/is-empty";
import Loader from "../../components/Loader/Loader";

const ChangePassword = (props) => {
    const { token } = useParams();

    const [passwordVisibility, setPasswordVisibility] = useState(false);
    const [confirmPasswordVisibility, setConfirmPasswordVisibility] = useState(false);

    const [isLoading, setIsLoading] = useState(false);
    const [isSubmitDisabled, setIsSubmitDisabled] = useState(false);
    const navigate = useNavigate();

    const Schema = Yup.object().shape({
        password: Yup.string()
            .matches(passwordRegex, "Password must contain at least one uppercase letter, one number, and one special character.")
            .required("Password cannot be empty"),
        confirm_password: Yup.string()
            .oneOf(
                [Yup.ref("password"), null],
                "Password and Confirm Password must match"
            )
            .matches(passwordRegex, "Confirm Password must contain at least one uppercase letter, one number, and one special character.")
            .required("Confirm Password cannot be empty"),
    });

  
  useEffect(() => {
    props.sendGetRequest({
        url: `forgot-password/validate/${token}`,
        onSuccess: function (response) {
        },
        onError: function (error) {
            const { data } = error.response;
            if (!data.success) {
                if (Array.isArray(data.data.token)) {
                    notification.error(...data.data.token);
                    setIsSubmitDisabled(true);
                    navigate('/admin/login');
                }
            }
        },
    });
  }, []);
  


  const formikProps = {
    initialValues: {
      password: "",
      confirm_password: "",
    },
    validationSchema: Schema,
    onSubmit: (values, formikHelpers) => {
        setIsLoading(true);
        const { password, confirm_password } = values;
        const data = {
            token,
            password,
            confirm_password
        };
        props.sendPostRequest({
            url: `/forgot-password/reset-password`,
            data,
            onSuccess: function (response) {
                setIsLoading(false);
                if (response.success) {
                    notification.success(response.message);
                    setIsSubmitDisabled(true);
                }
                setTimeout(() => {
                    navigate('/admin/login');
                }, 2000);
            },
            onError: function (error) {
                setIsLoading(false);
                const { data } = error.response;
                if (!data.success) {
                    if (!isEmpty(data?.data?.token) && Array.isArray(data.data.token)) {
                        notification.error(...data.data.token);
                    }
                }
                
            },
        });
    }
  };

  const changePasswordVisibility = () => {
    setPasswordVisibility(!passwordVisibility);
  };

  const changeConfirmPasswordVisibility = () => {
    setConfirmPasswordVisibility(!confirmPasswordVisibility);
  };

  return (
    <>
      <Loader isShowLoader={isLoading} />
      <Formik {...formikProps}>
        {(formik) => {
          const { values, handleChange, handleSubmit, handleBlur } = formik;
          return (
            <div className="signup-process">
              <div className="logo-side">
                <img src={logoLg} alt="" />
              </div>
              <div className="signup">
                <div className="cross-btn">
                  <Link to="/">
                    <img width="33" src={crossBtn} alt="" />
                  </Link>
                </div>
                <div className="signup-form">
                  <form onSubmit={handleSubmit}>
                    <h1>Change Password</h1>
                    <p className="r-p">
                      You Are One Password Away From Creating Something Amazing
                    </p>
                    <div className="form-group mb-0 mt-2">
                      <label className="same-label" htmlFor="password">
                        Password
                      </label>
                      <div className="password-group">
                        <input
                          type={passwordVisibility ? "text" : "password"}
                          className="form-control same-input"
                          name="password"
                          id="password"
                          placeholder="Password"
                          value={values.password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {!passwordVisibility && (
                          <img
                            src={visibilityOff}
                            onClick={changePasswordVisibility}
                            alt=""
                          />
                        )}
                        {passwordVisibility && (
                          <img
                            src={visibility}
                            onClick={changePasswordVisibility}
                            alt=""
                          />
                        )}
                      </div>
                      <ErrorMessage
                        name="password"
                        render={(error) => (
                          <span className="error">{error}</span>
                        )}
                      />
                    </div>
                    <div className="form-group mb-0 mt-2">
                      <label className="same-label" htmlFor="password">
                        Confirm Password
                      </label>
                      <div className="password-group">
                        <input
                          type={confirmPasswordVisibility ? "text" : "password"}
                          className="form-control same-input"
                          name="confirm_password"
                          id="confirm_password"
                          placeholder="Confirm Password"
                          value={values.confirm_password}
                          onChange={handleChange}
                          onBlur={handleBlur}
                        />
                        {!confirmPasswordVisibility && (
                          <img
                            src={visibilityOff}
                            onClick={changeConfirmPasswordVisibility}
                            alt=""
                          />
                        )}
                        {confirmPasswordVisibility && (
                          <img
                            src={visibility}
                            onClick={changeConfirmPasswordVisibility}
                            alt=""
                          />
                        )}
                      </div>
                      <ErrorMessage
                        name="confirm_password"
                        render={(error) => (
                          <span className="error">{error}</span>
                        )}
                      />
                    </div>
                    <button type="submit" className="btn btn-app" disabled={isSubmitDisabled}>
                      Change Password
                    </button>
                    <p className="login-here">
                      Don't have a account? <Link to="/signup">SignUp Now</Link>
                    </p>
                  </form>
                </div>
                <div className="signup-footer">
                  <ul className="languages d-none">
                    <li>English (UK)</li>
                    <li>हिन्दी</li>
                    <li>ਪੰਜਾਬੀ</li>
                    <li>বাংলা</li>
                    <li>Deutsch</li>
                    <li>ગુજરાતી</li>
                    <li>Español</li>
                  </ul>
                  <p>Copyright © 2025 MeetOcto.</p>
                </div>
              </div>
            </div>
          );
        }}
      </Formik>
    </>
  );
};

export default connect(null, { 
    sendGetRequest, 
    sendPostRequest  
})(withRouter(ChangePassword));
